import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { accountRoute } from '../../routes';

import connect from '../../utils/connect';
import baseUrl from '../../utils/baseUrl';

import Splitter from './block/splitter';
import AccountBlockCategoryList from './block/categoryList';
import ContentBlock from './block/content';
import ConfirmDialog from '../form/confirm';
import Spinner from '../svg/spinner';

// import translate from '../../utils/translate';
import { DateFormatter } from '../../utils/date';
import axios from 'axios';
import { dispatchError } from '../../actions/errors';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

import { JobListItem } from './jobListItem';

class AccountJobList extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		users: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
	};

	constructor() {
		super();

		this.mounted = true;

		this.state = {
			waiting: true,
			items: [],
		};
	}

	componentWillMount() {
		axios({
			url: `${baseUrl}/api/account/profiles/jobs`,
			method: 'get',
			responseType: 'json',
		})
		.then((res) => {
			const newState = {
				...this.state,
				waiting: false,
			};
			if (res.data && res.data.jobs) {
				newState.items = res.data.jobs;
			} else {
				this.props.dispatch(dispatchError('Invalid data received.'));
			}

			this.setState(newState);
		})
		.catch((res) => {
			this.props.dispatch(dispatchError(res.data));
			this.mounted && this.setState({
				...this.state,
				waiting: false,
			});
		});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		const jobs = this.state.items;
		const contentTitles = {
			ACTIVE: 'Active',
			INACTIVE: 'Inactive',
			EXPIRED: 'Expired',
		};

		const content = {
			ACTIVE: [],
			INACTIVE: [],
			EXPIRED: [],
		};

		for (let i = 0; i < jobs.length; i++) {
			const job = jobs[i];
			const createdDate = new DateFormatter(job.createdDate);
			let cat = false;

			if (new Date().getTime() - createdDate.getTime() >= (90 * (24 * 60 * 60 * 1000))) {
				cat = 'EXPIRED';
			} else {
				cat = job.activated ? 'ACTIVE' : 'INACTIVE';
			}

			if (cat) {
				content[cat].push(job);
			}
		}

		return (
			<div className='account-editorial'>
				<Helmet title='The FWA - Account - Jobs' />
				<ConfirmDialog ref='confirm' />

				<ContentBlock title='Jobs posted by you' sticky browser={this.props.browser}>
					<div className='account-block-content__content__buttons'>
						<Link to={accountRoute('/profile/jobs/create')} className='button button--dark '>Post job vacancy</Link>
					</div>
				</ContentBlock>

				{this.state.waiting && this.renderWaiting()}

				{!this.state.waiting && <Splitter className='hide-mobile' />}

				{!this.state.waiting && Object.keys(contentTitles).map((key) => {
					let title = contentTitles[key];
					return (
						<div key={title}>
							<AccountBlockCategoryList
								browser={this.props.browser}
								compComponent={JobListItem}
								title={title}
								content={content[key]}
								type={key}
								waiting={this.state.waiting}
								data={{
									updateItems: (items) => this.updateItems(items),
									dispatch: (arg) => this.props.dispatch(arg),
								}}
							/>
							<Splitter />
						</div>
					);
				})}

			</div>
		);
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	updateItems(items) {
		this.setState({
			...this.state,
			items,
		});
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountJobList);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobList.js
 **/